import { makeStyles } from '@mui/styles';

export const announcementStyles = makeStyles((theme) => ({
  labelText: {
    fontFamily: 'Open Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '700 !important',
    fontSize: '18px !important',
    lineHeight: '25px !important',
    color: '#14142B',
  },

  wizardNextBtn: {
    border: '2px solid #39A2DB !important',
    borderRadius: '24px !important',
    height: '46px',
  },
  wizardBtn: {
    height: '46px',
    width: '152px',
    fontSize: '15px',
    borderRadius: '24px',
    color: '#fff !important',
  },
  wizardBtnDisabled: {
    background: '#ddd !important',
    height: '46px',
    color: '#00000042 !important',
  },
  wizardCloneButton: {
    border: '2px solid #39A2DB !important',
    borderRadius: '24px !important',
    padding: '9px 17px !important',
    height: '49px',
  },
  wizardText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '600 !important',
    fontSize: '16px !important',
    lineHeight: '22px !important',
    color: '#A8A8A8 !important',
    margin: '0px 5px !important',
    maxWidth: '125px !important',
  },
  wizardContinueBtnText: {
    textTransform: 'capitalize',
    fontSize: '18px !important',
    fontWeight: '700 !important',
    fontFamily: 'Work Sans !important',
    color: '#39A2DB',
  },
  wizardBtnText: {
    textTransform: 'capitalize',
    fontSize: '18px !important',
    fontWeight: '700 !important',
    fontFamily: 'Work Sans !important',
  },
  cloneButtonText: {
    textTransform: 'capitalize',
    fontSize: '18px !important',
    fontWeight: '700 !important',
    fontFamily: 'Work Sans !important',
   color: '#39A2DB',
  }
}));

export const announcementMessageStyles = makeStyles((theme) => ({
  toolbarClass: {
    border: 'none',
    padding: '10px',
    borderRadius: '24px 24px 0px 0px',
    borderBottom: '3px solid #F1F0F5',
  },
  wrapperClass: {
    borderRadius: '24px',
    border: '3px solid #F1F0F5',
  },
  editorClass: {
    fontFamily: 'Work Sans !important',
    color: '#000000 !important',
    padding: '0px 12px !important',
    height: '48vh',
    overflowY: 'auto',
    borderRadius: '10px',
  },
}));

export const announcementDetailStyles = makeStyles((theme) => ({
  FromSelect: {
    border: '2px solid #EEEEEE',
    borderRadius: '24px !important',
    width: '100%',
    height: '50px !important',
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '16px !important',
    lightHeight: '22px !important',
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: '2px solid #39A2DB !important',
    },
    '&.Mui-disabled .MuiSvgIcon-root ': {
      fill: '#F1F0F5 !important',
    },
    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      border: '2px solid #F1F0F5 !important',
    },
    '& input.MuiInputBase-input::placeholder': {
      color: '#3CA2DC',
      textAlign: 'center',
      opacity: 1,
    },
    '& .MuiAutocomplete-endAdornment': {
      position: 'unset',
      margin: 0,
    },
  },
  subjectBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
}));
